import { render, staticRenderFns } from "./SalesOrderOverlay.vue?vue&type=template&id=46b6346d&"
import script from "./SalesOrderOverlay.vue?vue&type=script&lang=js&"
export * from "./SalesOrderOverlay.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderOverlay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports